import 'prop-types';
import styled from 'styled-components';
import { spacing4x } from '../../styles/spacing.js';
import { ActionToolbarItemWrapper } from './ActionToolbarItem.js';

var ActionToolbarDivider = styled.span.withConfig({
  displayName: "ActionToolbarDivider",
  componentId: "sc-1skw7yz-0"
})(["&&{display:inline-block;width:1px;height:100%;border-left-color:", ";border-left-style:solid;border-left-width:1px;padding-right:", ";vertical-align:top;}&&:first-child,&&:last-child{display:none;}&& + span:not(", "){display:none;}"], function (props) {
  return props.theme.neutralColors.silver;
}, spacing4x, ActionToolbarItemWrapper);

export { ActionToolbarDivider };
